module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Gamepad1-e221ea675e7b2bc577fb89c3f00f0e27.svg";